import script from "./boxTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./boxTop.vue?vue&type=script&lang=ts&setup=true"

import "./boxTop.vue?vue&type=style&index=0&id=3f679982&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f679982"]])

export default __exports__